import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Platform } from '@ionic/angular';

import { DomainService } from '../services/domain/domain.service';
import { StorageService } from '../services/storage/storage.service';

import { SplashScreen } from '@capacitor/splash-screen';
import { STORAGE_CONST } from '../constants/storage-constants';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(
    private storage: StorageService,
    private domainSvc: DomainService,
    private plt: Platform,
    private router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const isReady = await this.plt.ready();
    if (isReady) {
      if (Capacitor.isNativePlatform()) {
        setTimeout(async () => {
          await SplashScreen.hide();
          if (this.plt.is('capacitor') && this.plt.is('android')) {
            await EdgeToEdge.setBackgroundColor({ color: '#172d51' });
          } else {
            await StatusBar.setBackgroundColor({ color: '#172d51' });
          }
          StatusBar.setStyle({ style: Style.Dark });
        }, 1000);
      }
      const firstRunIsDone = await this.storage.get(STORAGE_CONST.FIRST_RUN_PERMISSION);
      if (firstRunIsDone) {
        const params = route.queryParams;
        this.router.navigate(['/app/add-files'], {
          replaceUrl: true,
          queryParams: params?.domainname && params?.locationid ? params : {},
        });
        return true;
      }
      return true;
    }
    return false;
  }

  /**
   * Get account details
   */
  async getaccountinfo() {
    const domaininfo = await this.storage.getJson(STORAGE_CONST.DOMAIN_INFO);
    if (domaininfo) {
      const result = await this.domainSvc.domainDetails(domaininfo.domainname);
      const primaryColor = result.customizations.Hex500;
      if (Capacitor.getPlatform() === 'android') {
        try {
          await EdgeToEdge.setBackgroundColor({ color: primaryColor });
        } catch (_error) {}
      }
      const r = document.querySelector(':root');
      r['style'].setProperty('--ion-color-eprintprimary', '' + primaryColor);
    }
  }
}
